import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navigation from '../../constants/navigation';
import Constants from '../../assets/constants';
import PropTypes from 'prop-types';

const Index = ({ showLogo }) => {
  const location = useLocation();

  return (
    <div
      className="grid width-100 text-left"
      style={{ paddingRight: '1.5em', paddingLeft: '1.5em' }}
    >
      <div className="grid-x padding-1">
        <div className="cell small-8">
          {showLogo && <div className="header">{Constants.NAME}</div>}
        </div>
        <div className="cell small-4 align-self-middle">
          <div className="grid-x grid-margin-x align-right">
            {Navigation.map((menuItem) => (
              <div className="shrink cell" key={menuItem.url}>
                <Link
                  className={`${location.pathname === menuItem.url && 'active'} link text-uppercase`}
                  to={menuItem.url}
                >
                  {menuItem.title}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

Index.propTypes = {
  showLogo: PropTypes.bool,
};

export default Index;
